<template>
  <Wrapper
      @open="onClick"
      code="cultery"
      label="Количество приборов"
      :icon="ICONS.cutlery"
      colStyle="padding-bottom: 5px;"
  >
    <template v-slot:label-side>
      <QuantityInput
          containerBorderColor="#AAAAAA"
          v-model="attrs.PERSONS_NUMBER"
          :btn="{
            size: '13px'
          }"
          class="c-quantity i-quantity bg-primary-brown-1"
          input-control-class="bg-primary-brown-1"
          :measure-show="false"
          :minimal="1"
      />
    </template>
  </Wrapper>
</template>

<script setup lang="ts">

import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";
import Wrapper from "./Wrapper/Wrapper.vue";
import {storeToRefs} from "pinia";
import {useStackRouter} from "@/packages/stack-router/hooks/useStackRouter";
import {VOrderDialogProps} from "@/components/Shop/VOrder/ui/Dialog/hook";
import QuantityInput from "@/components/Ui/QuantityInput.vue";
import {ICONS} from "@/assets/icons";

import CulteryDialog from "@/components/Shop/VOrder/ui/Dialog/Cultery.vue";
import {useVorderState} from "@/modules/shop/store/vorder-state";

const vorderStore = useVorderState()
const {} = storeToRefs(vorderStore)

const {attrs} = storeToRefs(vorderStore)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})

const stackRouter = useStackRouter()

const onClick = () => {
  stackRouter.getStack()?.push<VOrderDialogProps>(CulteryDialog, {
    ...props
  })
}

</script>

<style>

</style>
